class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, JSON.parse(this.dataset.keys), 0, true);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {

    
    super();
    this.accordionStates = new Map(); 

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
      
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
      this.restoreAccordionStates();
       this.discountCodeApplying();

    }, 300);

    this.addEventListener('change', (ev) => {      
      const otherInputs = document.querySelectorAll('.quantity__input:not([id="' + ev.target.id + '"])');
      otherInputs.forEach(input => {
        input.disabled = 'disabled';
      });
    });
    this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.addEventListener('click', (event) => {
      if (event.target.classList.contains('cart-item__customiser-link') || event.target.closest('.cart-item__customiser-link')) {
        const target = (event.target.classList.contains('cart-item__customiser-link')) ? event.target : event.target.closest('.cart-item__customiser-link');
        this.loadConfigurator(target);
      }
      if (event.target.classList.contains('design-duplicate__btn')) {
        const target = (event.target.classList.contains('design-duplicate__btn')) ? event.target : event.target.closest('.design-duplicate__btn');        
        this.loadConfigurator(target, true);
      }
    }, false);
    this.init();
    this.discountCodeApplying()
    
    //Add customer id to designs
    window.IsCustomerIdUpdated = false;
    this.addCustomerId();
  }

async discountCodeApplying() {
  const discountCodeApplyBtn = document.getElementById('apply-discount');

  if (!discountCodeApplyBtn) return;

  const wrongCodeText = discountCodeApplyBtn.dataset.wrong;
  const successCodeText = discountCodeApplyBtn.dataset.success;
  const emptyCodeText = discountCodeApplyBtn.dataset.empty;

  const discountMessage = document.getElementById('discount-message');
  const spinner = document.getElementById('spinner');

  // Track non-applicable codes
  const invalidCodes = new Set();

  discountCodeApplyBtn.addEventListener('click', async () => {
    const discountCodeInput = document.getElementById('discount-code');
    const discountCode = discountCodeInput.value.trim();

    discountMessage.textContent = "";

    if (discountCode === "") {
      discountMessage.textContent = emptyCodeText;
      return;
    }

    try {
      spinner.style.display = "block";

      // STEP 1: Fetch existing cart
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      let existingCodes = (cart.discount_codes || [])
        .map(dc => dc.code)
        .filter(code => code && !invalidCodes.has(code)); // Skip previously failed codes

      if (existingCodes.includes(discountCode)) {
        discountMessage.textContent = successCodeText + " (already applied)";
      } else {
        const updatedCodes = [...existingCodes, discountCode];

        // STEP 2: Try to apply all valid + new code
        const updateRes = await fetch(`/cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ discount: updatedCodes.join(',') }),
        });

        const updateData = await updateRes.json();

        const newCodeEntry = updateData.discount_codes?.find(code => code.code === discountCode);

        if (!newCodeEntry || newCodeEntry.applicable === false) {
          discountMessage.textContent = wrongCodeText;
          invalidCodes.add(discountCode); // Mark it as invalid
        } else {
          discountMessage.textContent = successCodeText;
        }
      }

      const updatedCartRes = await fetch('/cart.js');
      const updatedCart = await updatedCartRes.json();

      const discountCodes = (updatedCart.discount_codes || []).map(dc => ({
        code: dc.code,
        applicable: dc.applicable,
      }));

      const cartLevelDiscounts = (updatedCart.cart_level_discount_applications || []).map(d => ({
        title: d.title,
        type: d.target_type,
      }));

      this.updateCartContent?.(); 
    } catch (error) {
      console.error('Discount error:', error);
      discountMessage.textContent = wrongCodeText;
    } finally {
      spinner.style.display = "none";
    }
  });
}


//Add customerId to designs
async addCustomerId() {        
  let customerId = window.customerId;    
  let visitCounter;
  
  if(customerId) {
    window.IsCustomerIdUpdated = true;
    visitCounter = localStorage.getItem('visitCounter') ? parseInt(localStorage.getItem('visitCounter')) : 0;    
  }
  
  let isCustomerIdUpdated = window.IsCustomerIdUpdated;  
   
  if(isCustomerIdUpdated && visitCounter < 1) {
    let editDesignButtons = document.querySelectorAll('.cart-items__design-id');
    
    if (editDesignButtons) {
        let designIds = [];
        const baseUrl = window.levi9BaseUrl;
        const authToken = new AuthToken();
        const accessToken = await authToken.getToken(); // Wait for the token to resolve
      
        editDesignButtons.forEach(button => {
            let designId = button.dataset?.configuratorDesignId;
            if (designId) {                
                designIds.push(designId);
            }
        });

        if (designIds.length > 0) {
            await fetch(`${baseUrl}/ProductDesigns/updateCustomerIds`, {
                method: 'PUT',
                headers: {                      
                  "Content-Type": "application/json",
                  "x-token": accessToken,
                  "x-customerId": customerId,
                },
                body: JSON.stringify({ designIds })
            })
            .then(response => response.json())
            .then(data => console.log('Success:', data))
            .catch(error => console.error('Error:', error));
      }
      visitCounter++;
      localStorage.setItem('visitCounter', visitCounter);
    }
  }
}
  
 updateCartContent() { 
  const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        this.renderCart(state, close);        
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
    });    
}


  
  init() {
    
    this.querySelectorAll('.quantity__input').forEach(el => {
      if (el.disabled) {
        el.disabled = false;
      }
    });
    this.openProductList();
    this.checkQuantity();      
  }

  async loadConfigurator(target, isDuplicate) {    
    // this.productConfigurator = document.querySelector('product-configurator[data-section="header"]');
    this.productConfigurator = (this.productConfigurator) ? this.productConfigurator : document.querySelector('product-configurator:not([data-section="header"])');
    const dataset = target.dataset;
    let fromCart = dataset.fromcart;
    let duplicateDesignId;

    if(isDuplicate) {      
      duplicateDesignId = await this.duplicateDesign(dataset);
      fromCart = false;
    }
    
    if(dataset.percentage) {
      this.productConfigurator.dataset.percentage = JSON.parse(dataset.percentage);
    }
    
    const premiumGraphicProduct = JSON.parse(dataset.productPremiumgraphic)
    const isFromCart = fromCart;
    const variants = JSON.parse(dataset.variants);
    const product_variants = JSON.parse(dataset.productVariants);
    const variantsStock = JSON.parse(dataset.productVariantsstock);
    const sizesTableArray = JSON.parse(dataset.productProductimagesizes);
    window.urlReplace =`${target.dataset.productUrl}&_configurator_design_id=${dataset.configuratorDesignId}`;
    const eventData = {
      bubbles: true,
      detail: {        
        productCustomTags: JSON.parse(dataset.productcustomtags),
        configuratorDesignId: isDuplicate ? duplicateDesignId : dataset.configuratorDesignId,
        variants: variants,
        printing_variants: JSON.parse(dataset.printing),
        cartTotal: JSON.parse(dataset.cartTotal),
        tags: JSON.parse(dataset.tags),
        productHandler: dataset.productHandler,
        baseShopUrl: dataset.baseShopUrl,        
        fromCart: Boolean(isFromCart),
        product: {
          productSizeImageLink: dataset.productProductsizeimagelink,
          productImageSizes: sizesTableArray,
          productTranslation: JSON.parse(dataset.productProducttranslation),
          productColorTranslation: JSON.parse(dataset.productProductcolortranslation),
          id: dataset.productId,
          color:  dataset.color,
          quality: dataset.quality,
          variants: product_variants,
          variantsStock:variantsStock,
          premiumGraphic:premiumGraphicProduct
        }
      }
    };

    this.productConfigurator.dispatchEvent(new CustomEvent('shirtup:configure', eventData));
  }

  generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0; // Generate a random number (0-15)
      const v = c === 'x' ? r : (r & 0x3 | 0x8); // Use r for 'x' and modify for 'y'
      return v.toString(16); // Convert to hexadecimal
    });
  }

  async duplicateDesign(dataset) {      
      const designId = dataset.configuratorDesignId;
      const customerId = dataset.customer ? dataset.customer : localStorage.getItem('usersIds');
      const baseUrl = window.levi9BaseUrl;
      const authToken = new AuthToken();
      let customerIds = window.customerId;
      let isGuest = !customerIds;      
      if (designId && customerId && baseUrl) {
        const url = `${baseUrl}/ProductDesigns/${designId}/duplicate`;
  
        try {
            const accessToken = await authToken.getToken(); // Wait for the token to resolve
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-token": accessToken,
                    "x-customerId": customerId,
                },
                body: JSON.stringify({
                    id: designId,
                    customerId: customerId,
                    name: this.generateGUID(),
                    anonymous: isGuest
                }),
              });
  
              if (response.status === 200) {
                  const newId = await response.json(); // Wait for the response JSON
                  return newId; // Return the result
              } else {
                  console.error("Error duplicating design:", response);
              }
          } catch (error) {
              console.error("Error duplicating design:", error);
          }
      } else {
          console.error("Missing required data for duplication.");
      }
      return null; // Return null if something goes wrong
  }

  onChange(event) {
    if (event.target.getAttribute('form')) {
      const keys = event.target.dataset.keys ? JSON.parse(event.target.dataset.keys) : [];
      this.updateQuantity(event.target.dataset.index, keys, event.target.value, document.activeElement.getAttribute('name'), false);
    } else {
      const printIds = event.target.dataset.printIds ? JSON.parse(event.target.dataset.printIds) : [];      
      const orderDesignId = event.target.dataset.orderDesignId || "";
      const printingPrice = event.target.dataset.printingPrice;      
      this.addItem(event.target.name, printIds, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.designId, event.target.dataset.designName, event.target.dataset.smakeId, orderDesignId, printingPrice);
      this.checkQuantity();
    }
  }

  getSectionsToRender() {
    return [
       {
        id: 'main-cart-items',
        section: document.getElementById('cart-progress-wrapper').dataset.id,
        selector: '.free-shiping_bar',        
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
        
      },
           
    ];
  }

  addItem(id, printIds, quantity, name, designId, designName, smakeVariantId, orderDesignId, printingPrice) {
      this.saveAccordionStates();
      let formData = {
        items: [
          {
            id: id,
            quantity: quantity,
            properties: {
              '_designName': designName,
              '_type': 'configurator_product',
              '_configurator_design_id': designId,
              '_smake_variant_id': smakeVariantId,
              '_order_design_id': orderDesignId,
              '_for_line_item_id': id,
              '_print_price': printingPrice,
              '_print_positions': printIds.toString()
            }
          }
        ],
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      };
   
      const body = JSON.stringify(formData);
          fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.errors || 'An error occurred while adding the item to the cart.');
          });
        }
          return response.text();
      })
        .then((state) => {
          this.renderCart(state, false);
        }).catch((error) => {
          if(error){
            // this.showModal(error.message);
            console.log(error)
          }
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          errors.textContent = window.cartStrings.error;
          this.disableLoading();
          
        });
  }
  
  showModal(title) {
    // Create the modal HTML structure
    const modalHTML = `
      <popup-modal class="popup-modal">
        <button class="button link-text">
        </button>
        <dialog>
          <form method="dialog">
            <header>
              <button value="cancel" class="text_link link">
                <svg class="icon icon-close"><use href="#icon-close"></use></svg>
              </button>
            </header>
            <div class="rte">
              ${title}
            </div>
          </form>
        </dialog>
      </popup-modal>
      <style>
        dialog {
          display: none;
        }
        dialog[open] {
          display: block;
        }
        .modal-open {
          display: block;
        }
        .icon-close {
          cursor: pointer;
        }
      </style>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    const modal = document.querySelector(".popup-modal dialog");
    const closeBtn = modal.querySelector("button[value='cancel']");

    modal.showModal();

    closeBtn.onclick = function(event) {
      event.preventDefault();
      modal.close();
      modal.parentElement.remove(); 
      location.reload();
    }

    window.onclick = function(event) {
      if (event.target == modal) {
        modal.close();
        modal.parentElement.remove();
        location.reload();
      }
    }
  }
  renderCart(state, close) {
    const openDialog = this.querySelector('.cart-item__quantity dialog[open]');
    const parsedState = JSON.parse(state);    
    const cartFooter = document.getElementById('main-cart-footer');

    this.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      if (!container) return;

      const elementToReplace = section.selector
        ? (container.querySelector(section.selector) || container)
        : container;

      const sectionHTML = parsedState.sections?.[section.section];
      if (!sectionHTML) return;

      elementToReplace.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
      this.init();
    });

    // Re-bind controls (e.g. the quote/print button) inside the sections just replaced above.
    document.dispatchEvent(new CustomEvent('cart:updated'));

    // Derive cart empty/non-empty state from DOM (AJAX response may not include item_count).
    const itemCount = this.querySelectorAll('.cart-item__wrapper').length;
    this.classList.toggle('is-empty', itemCount === 0);
    if (cartFooter) cartFooter.classList.toggle('is-empty', itemCount === 0);
    let cartBubble = document.querySelector('.cart-count-bubble');
    if (cartBubble) cartBubble.classList.toggle('is-empty', itemCount === 0);
    this.disableLoading();
    this.restoreAccordionStates();
    
    this.checkQuantity();


    const popularCategoriesEl = document.querySelector('popular-categories');
    if (popularCategoriesEl) {
      if (itemCount === 0) {        
        popularCategoriesEl.classList.remove('cart-popular-categories-empty');
      } else {          
        popularCategoriesEl.classList.add('cart-popular-categories-empty');
      }
    }
    
  }  
  
  updateQuantity(line, keys, quantity, name, close) {
  this.saveAccordionStates();
  this.enableLoading(line);

  let updates = {};
  keys.forEach(key => {
    updates[key] = quantity;
  });

  const body = JSON.stringify({
    updates: updates,
    sections: this.getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname
  });

  // Step 1: Fetch cart before update and group variant quantities
  fetch('/cart.js')
    .then(res => res.json())
    .then(cartBefore => {
      const beforeQtyMap = {};
      cartBefore.items.forEach(item => {
        if (!beforeQtyMap[item.variant_id]) beforeQtyMap[item.variant_id] = { item, quantity: 0 };
        beforeQtyMap[item.variant_id].quantity += item.quantity;
      });

      // Step 2: Perform the cart update
      return fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body
      })
        .then(response => response.text())
        .then(state => {
          // Step 3: Fetch cart after update and group variant quantities
          fetch('/cart.js')
            .then(res => res.json())
            .then(cartAfter => {
              const afterQtyMap = {};
              cartAfter.items.forEach(item => {
                if (!afterQtyMap[item.variant_id]) afterQtyMap[item.variant_id] = { item, quantity: 0 };
                afterQtyMap[item.variant_id].quantity += item.quantity;
              });

              const removedItems = [];

              // Step 4: Compare quantities
              Object.keys(beforeQtyMap).forEach(variantId => {
                const before = beforeQtyMap[variantId];
                const afterQty = afterQtyMap[variantId]?.quantity || 0;

                if (afterQty < before.quantity) {
                  const qtyRemoved = before.quantity - afterQty;
                  const unitPrice = before.item.final_price;

                  removedItems.push({
                    item_id: before.item.sku || before.item.variant_id,
                    item_name: before.item.product_title,
                    item_brand: before.item.vendor,
                    item_category: before.item.product_type || null,
                    item_variant: before.item.variant_title,
                    product_id: String(before.item.product_id),
                    variant_id: String(before.item.variant_id),
                    quantity: qtyRemoved,
                    price: unitPrice
                  });
                }
              });

              // Step 5: Shopify Web Pixel event
              if (removedItems.length > 0 && typeof Shopify.analytics?.publish === 'function') {
                Shopify.analytics.publish('remove_product_test', {
                  items: removedItems
                });
              }

              this.renderCart(state, close);
            });
        });
    })
    .catch(() => {
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = window.cartStrings.error;
      this.disableLoading();
    });
}
  checkQuantity(){
  var inputElements = document.getElementsByClassName("quantity__input");
  if(inputElements){
  Array.from(inputElements).forEach(input=>{
  input.addEventListener('change', function() {
  const maxLimit = parseInt(input.getAttribute('data-number'));
  const value = parseInt(input.value);
  var outOfStockField = document.getElementById("out-of-stock-message");
  if (value > maxLimit) {
    input.value = maxLimit; // Set the value to the max limit
    outOfStockField.style.display = 'block';
  }
  else{
    outOfStockField.style.display = "none";
  }
  })
  });
  }
  }

  openProductList() {
    const size_dropdowns = document.querySelectorAll('.sizes-picker__dropdown');

    document.querySelectorAll('.cart-accordion-button').forEach(function(button) {
        button.addEventListener('click', function(event) {
            // Stop the event from bubbling up to the document
            event.stopPropagation();
    
            var contentSelector = this.getAttribute('data-target');
            var content = document.querySelector(contentSelector);
            var svg = this.querySelector('svg'); 
            
            // Hide all size dropdowns first
            size_dropdowns.forEach(function(dropdown) {
                if(dropdown != content)
                dropdown.removeAttribute('open');
                dropdown.style.display = "none";
                const svg = dropdown.previousElementSibling.querySelector('svg');
                if (svg) svg.classList.remove('rotate');
            });
                
            if (content.getAttribute('open') == null) {
                content.setAttribute('open', ''); 
                content.style.display = "block";
                svg.classList.add('rotate');
            } else {
                content.removeAttribute('open');
                content.style.display = "none";
                svg.classList.remove('rotate');
            }
        });
    });

    // Collapse dropdowns with the same toggle behavior when clicking outside
    document.addEventListener('click', function(event) {
        size_dropdowns.forEach(function(dropdown) {
            // Check if the click is outside both the dropdowns and the cart-accordion buttons
            if (!event.target.closest('.sizes-picker__dropdown') && !event.target.closest('.cart-accordion-button')) {
                const relatedButton = document.querySelector(`[data-target="#${dropdown.id}"]`);
                const svg = relatedButton ? relatedButton.querySelector('svg') : null;
                
                if (dropdown.getAttribute('open') !== null) {
                    // Collapse dropdown
                    dropdown.removeAttribute('open');
                    dropdown.style.display = "none";
                    if (svg) svg.classList.remove('rotate');
                }
            }
        });
    });
  }

  saveAccordionStates() {
    document.querySelectorAll('.cart-accordion-button').forEach(button => {
      const contentSelector = button.getAttribute('data-target');
      const isOpen = document.querySelector(contentSelector).hasAttribute('open');
      this.accordionStates.set(contentSelector, isOpen);
    });
  }
  restoreAccordionStates() {
  this.accordionStates.forEach((isOpen, contentSelector) => {
    const content = document.querySelector(contentSelector);
    if (!content) return; 

    const button = document.querySelector(`[data-target="${contentSelector}"]`);
    const svg = button.querySelector('svg');

    if (isOpen) {
      content.setAttribute('open', '');
      content.style.display = "block";
      svg.classList.add('rotate');
    } else {
      content.removeAttribute('open');
      content.style.display = "none";
      svg.classList.remove('rotate');
    }
  });
}
  getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    if (!selector) return doc.body?.innerHTML || '';
    const selected = doc.querySelector(selector);
    return selected ? selected.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    // document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
      
    }
  });
};



(() => {
 
  const SELECTORS = {
    button: '[data-print-cart-button]',
    message: '[data-print-cart-message]',
    translations: '[data-print-cart-translations]',
  };
  const SECTION_ID = 'print-cart';
  const IFRAME_ID = 'PrintCartFrame';
  const DEFAULT_TRANSLATIONS = {
    error: 'The print preview could not be loaded.',
    documentTitle: document.title,
  };
  class PrintCart {
    constructor(button) {
      this.button = button;
      const container = button.parentElement;
      this.message = container.querySelector(SELECTORS.message);
      this.translations = this.getTranslations(container);
      this.isPrinting = false;
      this.onClick = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClick);
    }
    getTranslations(container) {
      const translationElement = container.querySelector(SELECTORS.translations);
      if (!translationElement) {
        return DEFAULT_TRANSLATIONS;
      }
      try {
        return JSON.parse(translationElement.textContent);
      } catch (error) {
        console.error('Print cart translations are invalid JSON.', error);
        return DEFAULT_TRANSLATIONS;
      }
    }
    async onClick(event) {
      event.preventDefault();
      if (this.isPrinting || this.button.disabled) {
        return;
      }
      this.isPrinting = true;
      this.clearMessage();
      try {
        const sectionHtml = await this.fetchPrintSection();
        const iframe = this.createIframe();
        await this.writeIframeDocument(iframe, sectionHtml);
        await this.waitForDocumentAssets(iframe);
        this.printIframe(iframe);
      } catch (error) {
        console.error('Print cart error:', error);
        this.showMessage(this.translations.error);
      } finally {
        this.isPrinting = false;
      }
    }
    getSectionUrl() {
      const localeRoot = window.Shopify?.routes?.root || '/';
      const url = new URL(localeRoot, window.location.origin);
      url.searchParams.set('section_id', SECTION_ID);
      url.searchParams.set('_', Date.now().toString());
      return url.toString();
    }
    async fetchPrintSection() {
      const response = await fetch(this.getSectionUrl(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest',
        },
        cache: 'no-store',
      });
      if (!response.ok) {
        throw new Error(
          `Section Rendering API returned HTTP ${response.status}.`
        );
      }
      const html = await response.text();
      if (!html.trim()) {
        throw new Error('Print cart section returned empty HTML.');
      }
      const parser = new DOMParser();
      const parsedDocument = parser.parseFromString(html, 'text/html');
      const printContent = parsedDocument.querySelector('[data-print-cart]');
      if (!printContent) {
        throw new Error(
          `The "${SECTION_ID}" section does not contain [data-print-cart].`
        );
      }
      return printContent.outerHTML;
    }
    createIframe() {
      document.getElementById(IFRAME_ID)?.remove();
      const iframe = document.createElement('iframe');
      iframe.id = IFRAME_ID;
      iframe.className = 'print-cart-frame';
      iframe.title = this.translations.documentTitle;
      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('tabindex', '-1');
      document.body.appendChild(iframe);
      return iframe;
    }
    async writeIframeDocument(iframe, sectionHtml) {
      const iframeDocument =
        iframe.contentDocument || iframe.contentWindow?.document;
      if (!iframeDocument) {
        throw new Error('Print iframe document is unavailable.');
      }
      const printStylesheetUrl = this.getPrintStylesheetUrl();
      const documentLanguage =
        document.documentElement.lang || Shopify?.locale || 'en';
      iframeDocument.open();
      iframeDocument.write(`
        <!doctype html>
        <html lang="${this.escapeAttribute(documentLanguage)}">
          <head>
            <meta charset="utf-8">
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            >
            <title>
              ${this.escapeHtml(this.translations.documentTitle)}
            </title>
            <link
              rel="stylesheet"
              href="${this.escapeAttribute(printStylesheetUrl)}"
            >
          </head>
          <body class="print-cart-document">
            ${sectionHtml}
          </body>
        </html>
      `);
      iframeDocument.close();
      await new Promise((resolve, reject) => {
        if (iframeDocument.readyState === 'complete') {
          resolve();
          return;
        }
        const timeout = window.setTimeout(() => {
          reject(new Error('Print iframe loading timed out.'));
        }, 10000);
        iframe.addEventListener(
          'load',
          () => {
            window.clearTimeout(timeout);
            resolve();
          },
          { once: true }
        );
      });
    }
    getPrintStylesheetUrl() {
 
      const stylesheet = Array.from(
        document.querySelectorAll('link[rel="stylesheet"]')
      ).find((link) => {
        try {
          const url = new URL(link.href, window.location.origin);
          return url.pathname.includes('print-cart.css');
        } catch {
          return false;
        }
      });
      if (!stylesheet) {
        throw new Error(
          'print-cart.css is not loaded in the main document.'
        );
      }
      return stylesheet.href;
    }
    async waitForDocumentAssets(iframe) {
      const iframeDocument =
        iframe.contentDocument || iframe.contentWindow?.document;
      if (!iframeDocument) {
        return;
      }
      const imagePromises = Array.from(iframeDocument.images).map((image) => {
        if (image.complete) {
          return Promise.resolve();
        }
        return new Promise((resolve) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      });
      const fontPromise = iframeDocument.fonts?.ready
        ? iframeDocument.fonts.ready.catch(() => undefined)
        : Promise.resolve();
      await Promise.race([
        Promise.all([fontPromise, ...imagePromises]),
        new Promise((resolve) => window.setTimeout(resolve, 5000)),
      ]);
  
      await new Promise((resolve) => {
        iframe.contentWindow?.requestAnimationFrame(() => {
          iframe.contentWindow?.requestAnimationFrame(resolve);
        });
      });
    }
    printIframe(iframe) {
      const printWindow = iframe.contentWindow;
      if (!printWindow) {
        throw new Error('Print iframe window is unavailable.');
      }
      let removed = false;
      const removeIframe = () => {
        if (removed) {
          return;
        }
        removed = true;
        iframe.remove();
      };
      
      printWindow.addEventListener('afterprint', removeIframe, {
        once: true,
      });
      printWindow.focus();
      printWindow.print();
      window.setTimeout(removeIframe, 60000);
    }
    showMessage(message) {
      if (!this.message) {
        return;
      }
      this.message.textContent = message;
      this.message.hidden = false;
    }
    clearMessage() {
      if (!this.message) {
        return;
      }
      this.message.textContent = '';
      this.message.hidden = true;
    }
    escapeHtml(value) {
      const element = document.createElement('div');
      element.textContent = String(value ?? '');
      return element.innerHTML;
    }
    escapeAttribute(value) {
      return this.escapeHtml(value).replace(/`/g, '&#96;');
    }
  }
  function initializePrintCart(scope = document) {
    scope.querySelectorAll(SELECTORS.button).forEach((button) => {
      if (button.dataset.printCartInitialized === 'true') {
        return;
      }
      button.dataset.printCartInitialized = 'true';
      new PrintCart(button);
    });
  }
  document.addEventListener('DOMContentLoaded', () => {
    initializePrintCart();
  });
 
  document.addEventListener('shopify:section:load', (event) => {
    initializePrintCart(event.target);
  });
  document.addEventListener('cart:updated', () => {
    initializePrintCart();
  });
})();


(() => {
  const SELECTORS = {
    open: '[data-quote-open]',
    close: '[data-quote-close]',
    modal: '#QuoteModal',
    form: '#QuoteForm',
    input: '#QuoteForm-email',
    message: '#QuoteForm-message',
    fieldWrapper: '.newsletter-form__field-wrapper',
    submit: '.quote-modal__submit',
    submitText: '.quote-modal__submit-text',
    spinner: '.quote-modal__spinner',
  };

  const getText = (els, key) => els.modal.dataset[key] || '';

  const getEndpoint = () => {
    const baseUrl =
      window.levi9BaseUrl ||
      'https://apim-shirtup-prd-northeurope-001.azure-api.net/back-uat';
    return `${baseUrl}/Orders/draft`;
  };

  // GA4 / GTM
  const toAmount = (cents) => Math.round(Number(cents || 0)) / 100;

  const formatCartItem = (item, index) => {
    let sku = String(item.sku || item.variant_id || '');
    const vendor = (item.vendor || '').toLowerCase();

    if (vendor === 'midocean') {
      sku = sku.replace(/-/g, '');
    } else if (vendor === 'solo' && sku.length >= 8) {
      sku = sku.substring(0, 5) + sku.substring(5, 8);
    }

    return {
      item_id: sku,
      item_name: item.product_title || '',
      item_brand: item.vendor || '',
      item_category: item.product_type || '',
      item_variant: item.variant_title || '',
      price: toAmount(item.price),
      quantity: parseInt(item.quantity, 10) || 1,
      index: index || 0,
    };
  };
  debugger;
  const pushQuoteDataLayerEvent = (cart) => {
    try {
      const cartItems = cart.items || [];
      const value = toAmount(cart.total_price);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'quote_request_sent',
        total_value: value,
        unique_items: new Set(cartItems.map((item) => item.variant_id)).size,
        total_items: cart.item_count || 0,
        ecommerce: {
          currency: cart.currency || 'EUR',
          value,
          items: cartItems.map(formatCartItem),
        },
      });
    } catch (error) {
      console.error('quote_request_sent dataLayer error:', error);
    }
  };

  const getEls = () => {
    const modal = document.querySelector(SELECTORS.modal);
    if (!modal) return null;
    return {
      modal,
      form: modal.querySelector(SELECTORS.form),
      input: modal.querySelector(SELECTORS.input),
      message: modal.querySelector(SELECTORS.message),
      fieldWrapper: modal.querySelector(SELECTORS.fieldWrapper),
      submit: modal.querySelector(SELECTORS.submit),
      submitText: modal.querySelector(SELECTORS.submitText),
      spinner: modal.querySelector(SELECTORS.spinner),
    };
  };

  const showMessage = (els, text, type) => {
    els.message.textContent = text;
    els.message.hidden = false;
    els.message.classList.remove('quote-modal__message--error', 'quote-modal__message--success');
    els.message.classList.add(`quote-modal__message--${type}`);
    if (type === 'error') {
      els.input.setAttribute('aria-invalid', 'true');
      els.input.focus();
    } else {
      els.input.removeAttribute('aria-invalid');
    }
  };

  const setLoading = (els, loading) => {
    els.submit.disabled = loading;
    els.submit.setAttribute('aria-busy', String(loading));
    els.spinner.hidden = !loading;
    els.submitText.hidden = loading;
  };

  const reset = (els) => {
    els.form.reset();
    els.message.hidden = true;
    els.message.textContent = '';
    els.input.removeAttribute('aria-invalid');
    els.fieldWrapper.hidden = false;
    els.submit.hidden = false;
    setLoading(els, false);
  };

  const STORAGE_KEY = 'quoteSentCartToken';

  const hideQuoteButtons = () => {
    document.querySelectorAll(SELECTORS.open).forEach((btn) => {
      btn.hidden = true;
    });
  };

  const rememberQuoteSent = (cartToken) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, cartToken);
    } catch (e) {}
  };

 
  const applyQuoteState = async () => {
    let sentToken;
    try {
      sentToken = sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {}
    if (!sentToken || !document.querySelector(SELECTORS.open)) return;

    try {
      const cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
        headers: { Accept: 'application/json' },
      }).then((r) => r.json());
      if (cart.token === sentToken) hideQuoteButtons();
    } catch (e) {}
  };
    const setQuoteCartAttributes = async (email, draftId) => {
    const attributes = {
      _quote: 'true',
      _quote_email: email,
      _quote_date: new Date().toISOString(),
    };
    if (draftId) attributes._quote_draft = String(draftId);

    try {
      await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
      });
    } catch (error) {
      console.error('Quote cart attribute error:', error);
    }
  };

  const getDraftIdFromResponse = async (response) => {
    try {
      const data = await response.json();
      return data?.draftOrderId || data?.draftOrder?.id || data?.id || null;
    } catch (e) {
      return null;
    }
  };
  document.addEventListener('DOMContentLoaded', applyQuoteState);
  document.addEventListener('cart:updated', applyQuoteState);

  document.addEventListener('click', (event) => {
    if (event.target.closest(SELECTORS.open)) {
      const els = getEls();
      if (!els) return;
      event.preventDefault();
      reset(els);
      els.modal.showModal();
      els.input.focus();
      return;
    }

    const modal = event.target.closest(SELECTORS.modal);
    if (modal && (event.target === modal || event.target.closest(SELECTORS.close))) {
      modal.close();
    }
  });

  document.addEventListener('submit', async (event) => {
    if (!event.target.matches(SELECTORS.form)) return;
    event.preventDefault();

    const els = getEls();
    if (!els) return;
    els.message.hidden = true;

    const email = els.input.value.trim();
    if (!email || !els.input.checkValidity()) {
      showMessage(els, getText(els, 'textInvalidEmail'), 'error');
      return;
    }

    setLoading(els, true);

    try {
      const cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
        headers: { Accept: 'application/json' },
      }).then((r) => r.json());

      if (!cart.item_count) {
        showMessage(els, getText(els, 'textEmptyCart'), 'error');
        return;
      }

      const accessToken = await new AuthToken().getToken();
      const customerId = window.customerId || localStorage.getItem('usersIds');

      const headers = {
        'Content-Type': 'application/json',
        'x-token': accessToken,
      };
      if (customerId) headers['x-customerId'] = customerId;

      const response = await fetch(getEndpoint(), {
        method: 'POST',
        headers,
        body: JSON.stringify({
          cartToken: cart.token,
          email,
        }),
      });

      if (!response.ok) throw new Error(`Orders/draft returned HTTP ${response.status}`);

      els.fieldWrapper.hidden = true;
      els.submit.hidden = true;
      showMessage(els, getText(els, 'textSuccess'), 'success');

      hideQuoteButtons();
      rememberQuoteSent(cart.token);
      pushQuoteDataLayerEvent(cart);
      const draftId = await getDraftIdFromResponse(response);
      await setQuoteCartAttributes(email, draftId);
    } catch (error) {
      console.error('Quote error:', error);
      showMessage(els, getText(els, 'textError'), 'error');
    } finally {
      setLoading(els, false);
    }
  });
})();